export function getLeftMenuData() {
  return [
    {
      title: 'Home',
      key: 'dashboard',
      url: '/dashboard',
      icon: 'icon-home3',
      pro: false,
    },
    {
      title: 'Orders',
      key: 'orders',
      url: '/orders',
      icon: 'icon-receipt',
      pro: false,
    },
    {
      title: 'Shopper',
      key: 'shopper',
      url: '/shopper',
      icon: 'icon-cart-full',
      pro: false,
    },
    {
      title: 'Members',
      key: 'members',
      url: '/members',
      icon: 'icon-user',
      pro: false,
    },
    {
      title: 'Packages',
      key: 'packages',
      url: '/packages',
      icon: 'icon-cube',
      pro: false,
    },
    {
      title: 'Coupons',
      key: 'coupons',
      url: '/coupons',
      icon: 'icon-barcode3',
      pro: false,
    },
    {
      title: 'Couriers',
      key: 'couriers',
      url: '/couriers',
      icon: 'icon-truck',
      pro: false,
    },
    {
      title: 'Transactions',
      key: 'transactions',
      url: '/transactions',
      icon: 'icon-cactus',
      pro: false,
    },
    {
      title: 'Settings',
      key: 'settings',
      icon: 'icon-cog',
      url: '/settings',
    },
  ]
}
export function getSettingsMenuData(userId, isCurrentUser) {
  return [
    {
      title: 'Profile',
      key: 'member',
      url: `/member/${userId}`,
      shouldRender: true,
    },
    {
      title: 'Packages',
      key: 'packages',
      url: `/member/${userId}/packages`,
      shouldRender: !isCurrentUser,
    },
    {
      title: 'Orders',
      key: 'orders',
      url: `/member/${userId}/orders`,
      shouldRender: !isCurrentUser,
    },
    {
      title: 'Credit Cards',
      key: 'payments',
      url: `/member/${userId}/payment-methods`,
      shouldRender: !isCurrentUser,
    },
    {
      title: 'Address Book',
      key: 'addresses',
      url: `/member/${userId}/address-book`,
      shouldRender: !isCurrentUser,
    },
    {
      title: 'Transactions',
      key: 'transactions',
      url: `/member/${userId}/transactions`,
      shouldRender: !isCurrentUser,
    },
    {
      title: 'Invites',
      key: 'invites',
      url: `/member/${userId}/invites`,
      shouldRender: !isCurrentUser,
    },
  ]
}
